window.bambooWishlistHelper = {
    byProductId: {},
    htmlElementsByProductId: {},
    addHtmlElement: (params => {
        let bambooWishlist;
        if (params.notRendered) {
            bambooWishlist = [params];
        } else {
            const elements = [...document.querySelectorAll(`[data-id="${params.htmlElementId}"]`)];
            bambooWishlist = elements.map(e => JSON.parse(e.dataset.bambooWishlist))
        }
        bambooWishlist.forEach(bambooWishlist => {
            if (!window.bambooWishlistHelper.htmlElementsByProductId[bambooWishlist.productId]) {
                window.bambooWishlistHelper.htmlElementsByProductId[bambooWishlist.productId] = {
                    byVariantId: {
                        [bambooWishlist.variantId]: {
                            byHtmlElementId: {
                                [bambooWishlist.htmlElementId]: {
                                    processed: false,
                                    processing: false,
                                }
                            }
                        }
                    }
                };
                return;
            }
            if (!window.bambooWishlistHelper.htmlElementsByProductId[bambooWishlist.productId].byVariantId[bambooWishlist.variantId]) {
                window.bambooWishlistHelper.htmlElementsByProductId[bambooWishlist.productId].byVariantId[bambooWishlist.variantId] = {
                    byHtmlElementId: {
                        [bambooWishlist.htmlElementId]: {
                            processed: false,
                            processing: false,
                        }
                    }
                };
                return;
            }
            window.bambooWishlistHelper.htmlElementsByProductId[bambooWishlist.productId].byVariantId[bambooWishlist.variantId].byHtmlElementId[bambooWishlist.htmlElementId] = {
                processed: false,
                processing: false,
            };
        })
    }),
};
window.bambooWishlistHelper.currentUserEmail = window.settings.currentUser.email